export const staircaseConfig = {
    gameSlug: 'symbol-coding',
    category: 'feu_vivacite',
    variable: 'duration_ms',
    startValue: 2000,
    minValue: 600,
    maxValue: 3000,
    stepSizesByPhase: [400, 200, 100, 50],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    maxTrials: 30,
    direction: 'down-easier',
};
function buildVariant(level) {
    if (level <= 10) {
        return { level, responseWindowMs: 2400, nPairs: 6, label: 'Découverte' };
    }
    if (level <= 20) {
        return { level, responseWindowMs: 2000, nPairs: 7, label: 'Élargissement' };
    }
    if (level <= 30) {
        return { level, responseWindowMs: 1700, nPairs: 8, label: 'Tempo soutenu' };
    }
    if (level <= 40) {
        return { level, responseWindowMs: 1400, nPairs: 9, label: 'Pression vitesse' };
    }
    return { level, responseWindowMs: 1100, nPairs: 9, label: 'Limite vivacité' };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
export const timing = {
    fixationMs: 300,
    feedbackMs: 500,
    itiMs: 500,
};
export const paradigmMeta = {
    slug: 'symbol-coding',
    paradigm: 'Symbol Coding (WAIS-IV, Wechsler 2008)',
    category: 'feu_vivacite',
    goal: 'Vitesse psychomotrice : association symbole-chiffre rapide.',
};
//# sourceMappingURL=params.js.map